/**
 * デバッグの時のみコンソールにデバッグ情報を出力する
 * リリースビルド時にコンソール出力をしたいときは
 * productionを条件に追加する
 * @param value コンソール出力文字
 */
export function consoleLog(value) {
  if('development' == process.env.NODE_ENV
      /* || production == process.env.NODE_ENV */){
    console.log(value)
  }
}


// WEBPACK FOOTER //
// ./src/components/Utility/UtilityConsoleLog.js